import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { MessageStoreService } from '@app/ngrx-message/services/message/message-store.service';
import { ExternalVendorActions } from '@usf/ngrx-product';
import { tap } from 'rxjs/operators';
import { MessageTypeEnum } from '@app/ngrx-message/constants/messageTypeEnum';
import { Message } from '@app/ngrx-message/models/client/message';

@Injectable({
  providedIn: 'root',
})
export class ManageVendorsEffects {
  createVendorSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ExternalVendorActions.createSuccess),
        tap(action => {
          this.displaySuccessToast('i18n.vendors.createVendorSuccess');
        }),
      ),
    { dispatch: false },
  );

  createVendorFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ExternalVendorActions.createFail),
        tap(action => {
          this.displayFailToast('i18n.vendors.createVendorFail');
        }),
      ),
    { dispatch: false },
  );

  editVendorSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ExternalVendorActions.editSuccess),
        tap(action => {
          this.displaySuccessToast('i18n.vendors.editVendorSuccess');
        }),
      ),
    { dispatch: false },
  );

  editVendorFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ExternalVendorActions.editFail),
        tap(action => {
          this.displayFailToast('i18n.vendors.editVendorFail');
        }),
      ),
    { dispatch: false },
  );

  deleteVendorSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ExternalVendorActions.deleteSuccess),
        tap(action => {
          this.displaySuccessToast('i18n.vendors.deleteVendorsSuccess');
        }),
      ),
    { dispatch: false },
  );

  deleteVendorFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ExternalVendorActions.deleteFail),
        tap(action => {
          this.displayFailToast('i18n.vendors.deleteVendorsFailure');
        }),
      ),
    { dispatch: false },
  );

  displayFailToast(message: string): void {
    this.messageStoreService.upsertMessage({
      type: MessageTypeEnum.error,
      display: this.translateService.instant(message),
      toast: true,
      sticky: true,
    } as Message);
  }

  displaySuccessToast(message: string): void {
    this.messageStoreService.upsertMessage({
      type: MessageTypeEnum.success,
      display: this.translateService.instant(message),
      toast: true,
      sticky: false,
    } as Message);
  }

  constructor(
    private actions$: Actions,
    private translateService: TranslateService,
    private messageStoreService: MessageStoreService,
  ) {}
}
